import React, {useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import { Button, Card, CardBody } from 'reactstrap';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import CalendarToolbar from '../CalendarToolbar'
import _moment from '../../libs/moment';
import { isAndroidOrIos } from '../../helpers/Utils';

const CustomCalendar = (props) => {
  const [data, setData] = useState([])
  const [diff, setDiff] = useState(0)
  const [prevDiff, setPrevDiff] = useState(0)
  const {ctxCruGrid, L} = props
  const localizer = momentLocalizer(_moment)

  useEffect(() => {
    const remapData = () => {
      let data = props.ctxCruGrid.state.data
      data = data.map(item => {
        const start = _moment(item.startDate).toDate()
        const end = _moment(item.endDate).toDate()
        const isAllday = (start.getDay() !== end.getDay()) || (start.getHours() === 0 && end.getHours() === 23)
        item = {
          id: item.ID,
          title: item.name,
          allDay: isAllday,
          start: start,
          end: end,
          titleHtml: `${!isAllday ? `<strong>${_moment(start).format('HH:mm ')}</strong>` : ''}${item.name}`
        }
        return item
      })
      setData(data)
    }
    remapData()
  }, [props])

  useEffect(() => {
    setPrevDiff(diff)
  }, [diff])

  useEffect(() => {
    if (prevDiff !== diff) {
      ctxCruGrid.view.config.customPathGet = `admActivity/month/${diff}`
      ctxCruGrid.getData()
    }
  }, [prevDiff, diff, ctxCruGrid])

  const onNavigate = (date) => {
    const currentMonth = _moment().startOf('month')
    const selectedMonth = _moment(date).startOf('month')
    const diff = selectedMonth.diff(currentMonth, 'months')
    setDiff(diff)
  }

  const onSelectEvent = (e) => {
    if (!isAndroidOrIos()) ctxCruGrid.getDataById(e.id)
  }

  const onSelectSlot = (e) => {
    ctxCruGrid.state.formFields.map(f => {
      if (f.name === 'startDate') f.value = _moment(e.start).format('YYYY-MM-DD HH:mm:ss')
      if (f.name === 'endDate') f.value = _moment(e.end).format('YYYY-MM-DD HH:mm:ss')
      return f
    })
    ctxCruGrid.toggle()
  }

  const ContexMenu = (event) => {
    return <div className="dropdown-menu show">
      <button type="button" className="dropdown-item" onClick={() => { ctxCruGrid.getDataById(event.id) }}><i className='simple-icon-pencil'></i>{L['main.edit']}</button>
      <button type="button" className="dropdown-item" onClick={() => { ctxCruGrid.toggleDelete(event.id) }}><i className='simple-icon-trash'></i>{L['main.delete']}</button>
    </div>
  }

  const showMenu = (e, event) => {
    e.preventDefault()
    var menus = document.querySelectorAll('.rbc-event-context-menu')
    menus.forEach(function(menu) {
      menu.parentNode.removeChild(menu)
    })
    var div = document.createElement('div')
    div.classList.add('rbc-event-context-menu')
    div.style.top = e.clientY + window.scrollY + 'px';
    div.style.left = e.clientX + window.scrollX + 'px';
    ReactDOM.render(<ContexMenu {...event}></ContexMenu>, div);
    document.body.appendChild(div)
    div.addEventListener('click', function() {
      if (document.body.contains(div)) document.body.removeChild(div)
    })
    div.addEventListener('mouseleave', function() {
      if (document.body.contains(div)) document.body.removeChild(div)
    })
    document.addEventListener('click', function(event) {
      if (!event.target.classList.contains('rbc-event-context-menu') && document.body.contains(div)) {
        document.body.removeChild(div)
      }
    }, { once: true })
  }

  const eventWrapperComponent = ({ event, children }) => (
    <div
      onClick={
        e => {
          if (isAndroidOrIos()) showMenu(e, event)
        }
      }
      onContextMenu={
        e => {
          if (!isAndroidOrIos()) showMenu(e, event)
        }
      }
    >
      {children}
    </div>
  )

  const eventComponent = ({ event }) => (
    <div className='text-left' dangerouslySetInnerHTML={{ __html: event.titleHtml }} />
  )

  const now = new Date()

  const dayStyleGetter = date => {
    if (_moment(date).isSame(now, 'day')) {
      return {
        className: 'rbc-highlight-today'
      }
    }
    return {}
  }

  return (
    <div>
      <Button size="sm" className="mb-3 d-block d-sm-none" color="primary" onClick={ctxCruGrid.toggle}>{L["main.create"]}</Button>
      <Card className={"mb-4"}>
        {ctxCruGrid.state.progressBar && <div className="progress"><div className="indeterminate"></div></div>}
        <CardBody>
          <Calendar
            localizer={localizer}
            action={'select'}
            events={data}
            views={['day','week','month']}
            defaultDate={new Date()}
            selectable
            // showAllEvents
            onSelectEvent={onSelectEvent}
            onSelectSlot={onSelectSlot}
            onNavigate={onNavigate}
            dayPropGetter={dayStyleGetter}
            components={
              {
                toolbar : toolbar => <CalendarToolbar {...toolbar} toggle={ctxCruGrid.toggle} L={L}/>,
                eventWrapper: eventWrapperComponent,
                event: eventComponent
              }
            }
            formats={
              {
                monthHeaderFormat: (date, culture, localizer) => `${localizer.format(date, 'MMMM YYYY', culture)}`.toUpperCase(),
                dayHeaderFormat: (date, culture, localizer) => `${localizer.format(date, 'DD MMMM YYYY', culture)}`.toUpperCase(),
                dayRangeHeaderFormat: ({ start, end }, culture, localizer) => `${localizer.format(start, 'DD MMMM', culture)} - ${localizer.format(end, 'DD MMMM', culture)}`.toUpperCase()
              }
            }
          />
        </CardBody>
      </Card>
    </div>
  )
}
export default CustomCalendar